import { render, staticRenderFns } from "./DBind.vue?vue&type=template&id=44c5f488"
import script from "./DBind.vue?vue&type=script&lang=js"
export * from "./DBind.vue?vue&type=script&lang=js"
import style0 from "./DBind.vue?vue&type=style&index=0&id=44c5f488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports